@if (gotDgProperties) {
  <app-grid-view #gridView
    [apiPath]="dgApiPath"
    [dgActionColumn]="dgActionColumn"
    [dgColumns]="dgColumns"
    [dgPopup]="dgPopup"
    [dgProperties]="dgProperties"
    (addButtonClick)="gridAddButtonClick($event)"
    (editButtonClick)="gridEditButtonClick($event)"
  ></app-grid-view>
}
